<template lang="pug">
  .progress-bar-wrapper
    transition(name="fade")
      .progress-bar(v-if="showLoader")
        .progress-bar-fill
          .loading-text Lade Buchungen ...
</template>

<script>
export default {
  data() {
    return {
      showLoader: false
    }
  },
  mounted() {
    this.$root.$on('startLoadingBookingData', () => {
      this.showLoader = true;
    });
    this.$root.$on('stopLoadingBookingData', () => {
      this.showLoader = false;
    });
  }
}
</script>

<style lang="scss" scoped>
.progress-bar-wrapper {
  width: 500px;
}

.progress-bar {
  background-color: #e0e0e0;
  margin: 0 $sm-space;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .2);
}

.progress-bar-fill {
  height: 16px;
  width: 100%;
  border-radius: 3px;
  background: linear-gradient(270deg,#F59E0B, #6B7280, #EF4444, #10B981);
  background-size: 800% 800%;

  -webkit-animation: AnimationName 2s ease infinite;
  -moz-animation: AnimationName 2s ease infinite;
  animation: AnimationName 2s ease infinite;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  color: white;
}

@-webkit-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>